import React from "react";
import { t } from "../../utils/i18n";

const SuccessAddAppModal = ({ action }) => {

  const handleReload = () => {
    window.location.href = "/partners/api_keys/";
  };  

  return (
    <div
      className="modal-delistoffers-alert-cont"
      aria-hidden="true"
      aria-labelledby="delistOffers"
    >
      <div>
        <h5 className="delistoffer-modal-title">
          <i className="fas fa-check-circle"></i>
          <span>{t(`referrals.partners_app.success_${String(action).toLowerCase()}`)}</span>
        </h5>

        <div className="delistoffer-modal-buttons-section">
          <button
            type="button"
            className="delistoffer-modal-tradeaction-proceedbtn"
            onClick={handleReload}
          >
            {t("referrals.partners_app.okay")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessAddAppModal;
